import type { StopListSettingsModel } from '@/shared/generated'

import { StopListCustomRulesView } from './StopListCustomRulesView'
import { StopListDefaultRulesView } from './StopListDefaultRulesView'

export function StopListView({
	settings,
	compact = false,
}: {
	settings?: StopListSettingsModel
	compact?: boolean
}) {
	return (
		<div className='flex flex-col gap-2'>
			<StopListDefaultRulesView settings={settings} compact={compact} />
			<StopListCustomRulesView settings={settings} compact={compact} />
		</div>
	)
}
